import './index.scss';

export class ProductSetPickerPayment extends HTMLElement {
  constructor() {
    super();
    this.model = {};
  }
  updateModel(model) {
    this.model = model;
    this.render();
  }
  render() {
    const { product, finishSelected, checkoutPriceLabel } = this.model;
    const template = `
      <span class="payment">${checkoutPriceLabel}</span>
      <span class="original">${finishSelected ? product.price.label : ''}</span>
    `;
    this.innerHTML = template;
  }
}

if (!customElements.get('product-set-picker-payment')) {
  customElements.define('product-set-picker-payment', ProductSetPickerPayment);
}
